export const CARE_PLAN_TASK_FIELDS = {
  title: "",
  description: "",
  resident_id: "",
  rd_care_plan_version_id: "",
  minimum_employees_required: "",
  scheduled_at: "",
  task_template_id: "",
};

const cleanMinStaff = (v) => {
  if (v === "" || v === null || v === undefined) return undefined;
  const n = parseInt(v, 10);
  if (Number.isNaN(n) || n < 1) return undefined;
  return n;
};

export const buildCarePlanTaskPayload = (form = {}) => {
  const {
    title = "",
    description = "",
    resident_id = "",
    rd_care_plan_version_id = "",
    minimum_employees_required = "",
    task_template_id = "",
    scheduled_at = null,
  } = form;
  const payload = {
    title: String(title).trim(),
    description: String(description).trim(),
    resident_id,
    rd_care_plan_version_id,
  };
  const min = cleanMinStaff(minimum_employees_required);
  if (min !== undefined) payload.minimum_employees_required = min;
  if (task_template_id) payload.task_template_id = task_template_id;
  if (scheduled_at) payload.scheduled_at = scheduled_at;
  return payload;
};

export const buildCarePlanTaskEditPayload = (form = {}) => {
  const {
    title = "",
    description = "",
    minimum_employees_required = "",
    task_template_id = "",
  } = form;
  const payload = {
    title: String(title).trim(),
    description: String(description).trim(),
  };
  const min = cleanMinStaff(minimum_employees_required);
  if (min !== undefined) payload.minimum_employees_required = min;
  if (task_template_id) payload.task_template_id = task_template_id;
  // Always send when the caller provided the key, so edits can set OR clear it.
  if ("scheduled_at" in form) payload.scheduled_at = form.scheduled_at || null;
  return payload;
};
